var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbmes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0354004,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#007FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2422 23.6425L18.059 20.2476L11.8479 23.6425L18.6801 16.3894L21.941 19.7845L28.0746 16.3894L21.2422 23.6425ZM20 8.05615C13.0965 8.05615 7.5 13.238 7.5 19.6302C7.5 23.2726 9.31777 26.5214 12.1584 28.6431V33.0562L16.4145 30.7202C17.5504 31.0345 18.7537 31.2042 20 31.2042C26.9035 31.2042 32.5 26.0224 32.5 19.6302C32.5 13.238 26.9035 8.05615 20 8.05615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbmes);
export default __webpack_public_path__ + "static/media/fbmes.99bcb2604233ea03647dee313bb3d917.svg";
export { ForwardRef as ReactComponent };